import { createErrorSelector, createLoadingSelector } from "../../utils/reduxUtils";
import { RESERVATIONS_PREVIOUS_INDICATORS } from "../actions";

export const reservationsPreviousIndicatorsSelector = () => (state: any) => state.reservationsPreviousIndicators;

export const reservationsPreviousIndicatorsLoadingSelector = createLoadingSelector([RESERVATIONS_PREVIOUS_INDICATORS]);
export const reservationsPreviousIndicatorsErrorSelector = createErrorSelector([RESERVATIONS_PREVIOUS_INDICATORS]);
